<template>
    <div ref="pdfContent" style="display: none;">
      <div class="pdf-template">
        <div class="header">
          <img src="/logo.png" alt="Logo" width="100" style="float: left; margin-right: 10px;" />
          <div class="address-block">
            <p>PROSECO</p>
            <p>Bernstrasse 131</p>
            <p>3052 Zollikofen</p>
          </div>
        </div>
  
        <h2 style="text-align: center; margin-top: 20px;">Artikelannahme</h2>
        <p>Kunde: {{ customerName }}</p>
        <p>Kundennummer: {{ customerId }}</p>
  
        <table>
          <thead>
            <tr>
              <th>Artikelnummer</th>
              <th>Artikel</th>
              <th v-if="includePrice">Preis</th>
              <th>Angenommen am</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="article in articles" :key="article.ArticleId">
              <td>{{ article.ArticleId }}</td>
              <td>{{ article.Name }}, {{ article.Color }}</td>
              <td v-if="includePrice">{{ $formatPrice(article.PriceDiscountLevel3 ?? article.PriceDiscountLevel2 ?? article.PriceDiscountLevel1 ?? article.SalePrice) }}</td>
              <td>{{ formatDate(article.ReceivedDate) }}</td>
            </tr>
          </tbody>
        </table>
  
        <div class="footer">
          <!-- Fußzeile optional -->
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import html2pdf from "html2pdf.js";
  
  export default {
    props: {
      customerName: String,
      customerId: Number,
      articles: Array,
      includePrice: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      formatDate(date) {
        return date
          ? new Date(date).toLocaleDateString("de-DE")
          : "-";
      },
      generatePdf() {
        this.$refs.pdfContent.style.display = 'block';
  
        this.$nextTick(() => {
          const element = this.$refs.pdfContent;
          const options = {
            margin: 0.5,
            filename: `Annahmeschein_${this.customerName}.pdf`,
            image: { type: "jpeg", quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: "in", format: "A4", orientation: "portrait" }
          };
  
          const worker = html2pdf().set(options).from(element).toPdf();
  
          worker.get('pdf').then(pdf => {
            const totalPages = pdf.internal.getNumberOfPages();
            for (let i = 1; i <= totalPages; i++) {
              pdf.setPage(i);
              const pageWidth = pdf.internal.pageSize.getWidth();
              const pageHeight = pdf.internal.pageSize.getHeight();
              const text = `Seite ${i} von ${totalPages}`;
              const textWidth = pdf.getTextWidth(text);
              const x = (pageWidth - textWidth) / 2;
              const y = pageHeight - 0.3;
              pdf.text(text, x, y);
            }
          }).then(() => worker.save())
            .then(() => {
              this.$refs.pdfContent.style.display = 'none';
            });
        });
      }
    }
  };
  </script>
  
  <style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Marcellus&display=swap');
  
  .pdf-template {
    font-family: 'Marcellus', Arial, sans-serif;
    position: relative;
    padding-bottom: 1in;
  }
  
  .header {
    display: flex;
    margin-bottom: 20px;
    position: relative;
  }
  
  .address-block {
    position: absolute;
    top: 30px;
    right: 0;
    width: 200px;
    text-align: left;
  }
  .address-block p {
    margin: 0;
    line-height: 1.2;
  }
  
  table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 20px;
  }
  
  th, td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: left;
  }
  
  th {
    background-color: #f2f2f2;
  }
  
  /* Spaltenbreiten anpassen */
  th:nth-child(1), td:nth-child(1) { width: 10%; }
  th:nth-child(2), td:nth-child(2) { width: 50%; }
  th:nth-child(3), td:nth-child(3) { width: 20%; }
  th:nth-child(4), td:nth-child(4) { width: 20%; }
  
  .footer {
    text-align: center;
    margin-top: 20px;
  }
  </style>
  